import { IconButton, Tooltip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import React, { FC } from "react";
import UnfoldLessIcon from "@mui/icons-material/UnfoldLess";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";

interface ShootTimeExpandButtonProps {
  expanded: boolean;
  onToggle: () => void;
}

export const ShootTimeExpandButton: FC<ShootTimeExpandButtonProps> = ({
  expanded,
  onToggle,
}) => {
  const { t } = useTranslation();
  const label = t(
    expanded
      ? "components.categoryCollectionProfile.images.collapseBehavior"
      : "components.categoryCollectionProfile.images.expandBehavior"
  );

  return (
    <div className="flex items-center gap-0.5">
      <Typography variant="caption">
        {t("views.categoryTemplates.tabs.shootTime")}
      </Typography>
      <Tooltip arrow title={label}>
        <IconButton
          size="small"
          aria-expanded={expanded}
          aria-label={label}
          onClick={onToggle}
        >
          {expanded ? (
            <UnfoldLessIcon fontSize="small" />
          ) : (
            <UnfoldMoreIcon fontSize="small" />
          )}
        </IconButton>
      </Tooltip>
    </div>
  );
};
